const EightExamCenter = () => import('../pages/eightExamCenter/index.vue');
const EightExamUpload = () => import('../pages/eightExamCenter/upload.vue');
const EightExamWaiting = () => import('../pages/eightExamCenter/waiting.vue');
const EightExamReport = () => import('../pages/eightExamCenter/report.vue');
const EightExamAnswers = () => import('../pages/eightExamCenter/answers.vue');

export default [
  {
    path: '/eightExamCenter',
    name: 'eightExamCenter',
    component: EightExamCenter,
    meta: {
      title: '模考中心',
    },
  },
  {
    path: '/eightExamCenter/:examId/upload',
    name: 'eightExamUpload',
    component: EightExamUpload,
    meta: { title: '提交答案' },
  },
  {
    path: '/eightExamCenter/:examId/waiting',
    name: 'eightExamWaiting',
    component: EightExamWaiting,
    meta: { title: '模考结果' },
  },
  {
    path: '/eightExamCenter/:examId/report',
    name: 'eightExamReport',
    component: EightExamReport,
    meta: { title: '模考报告' },
  },
  {
    path: '/eightExamCenter/:examId/answers',
    name: 'eightExamAnswers',
    component: EightExamAnswers,
    meta: { title: '我的答案' },
  },
];
